import request from '@/common/request';

export function createToken(data) {
	return request.post('/auth/token', data);
}

export function refreshToken() {
	return request.post('/auth/token/refresh');
}
